import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onAddNoteRes } from "./helper";

const addNote = async (data: NoteReqT) => axios.post(Routes.ADD_NOTE, data);

export const useAddNote = () =>
  useMutation({
    mutationKey: [Keys.ADD_NOTE_MUT],
    mutationFn: addNote,
    onSuccess: onAddNoteRes,
  });
